/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { GovHeraldRuEagleIcon16Light } from './GovHeraldRuEagleIcon16Light';
import { GovHeraldRuEagleIcon16Regular } from './GovHeraldRuEagleIcon16Regular';
import { GovHeraldRuEagleIcon16Solid } from './GovHeraldRuEagleIcon16Solid';
import { GovHeraldRuEagleIcon20Light } from './GovHeraldRuEagleIcon20Light';
import { GovHeraldRuEagleIcon20Regular } from './GovHeraldRuEagleIcon20Regular';
import { GovHeraldRuEagleIcon20Solid } from './GovHeraldRuEagleIcon20Solid';
import { GovHeraldRuEagleIcon24Regular } from './GovHeraldRuEagleIcon24Regular';
import { GovHeraldRuEagleIcon24Solid } from './GovHeraldRuEagleIcon24Solid';
import { GovHeraldRuEagleIcon32Regular } from './GovHeraldRuEagleIcon32Regular';
import { GovHeraldRuEagleIcon64Regular } from './GovHeraldRuEagleIcon64Regular';
var sizes = {
    16: {
        light: GovHeraldRuEagleIcon16Light,
        regular: GovHeraldRuEagleIcon16Regular,
        solid: GovHeraldRuEagleIcon16Solid,
    },
    20: {
        light: GovHeraldRuEagleIcon20Light,
        regular: GovHeraldRuEagleIcon20Regular,
        solid: GovHeraldRuEagleIcon20Solid,
    },
    24: {
        regular: GovHeraldRuEagleIcon24Regular,
        solid: GovHeraldRuEagleIcon24Solid,
    },
    32: {
        regular: GovHeraldRuEagleIcon32Regular,
    },
    64: {
        regular: GovHeraldRuEagleIcon64Regular,
    },
};
export var GovHeraldRuEagleIcon = forwardRef('GovHeraldRuEagleIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
